<div class="flex justify-content-center">
  <shared-title>Lista de QR</shared-title>
</div>

<div class="grid w-full justify-content-center">
  <!-- Select Link -->
  <div class="col-12 sm:col-12 md:col-8 lg:col-8 xl:col-8">
    <div class="h-full">
      <div class="overflow-auto custom-scroll">
        <mat-selection-list
          hideSingleSelectionIndicator="true"
          [multiple]="false">
          @for (element of listOfQR; track element) {
            <mat-list-option
              class="text-xs flex-wrap sm:text-xs md:text-sm lg:text-sm xl:text-sm"
              (click)="setCurrentQR(element)"
              [value]="element">
              <div class="flex justify-content-between">
                <a> {{ element.floor_name }} > {{ element.workplace_name }}</a>
              </div>
            </mat-list-option>
          }
        </mat-selection-list>
      </div>
      <shared-button
        class="flex justify-content-center"
        [typeBtn]="'submit'"
        [icon]="'cloud_download'"
        [color]="'accent'"
        [routerLink]="['admin/pdf']"
        (click)="qrlistsend()">
        Descargar lista QR
      </shared-button>
    </div>
  </div>

  <!-- QR -->
  <div class="col-7" id="element-to-capture" style="width: 300px">
    <div class="flex justify-content-center align-items-center">
      <qrcode
        #parent
        (qrCodeURL)="onChangeURL($event)"
        [qrdata]="currentQR.workplace_id"
        [width]="256"
        [errorCorrectionLevel]="'M'"></qrcode>
    </div>
    <div
      class="text-center sm:text-center md:text-left lg:text-left xl:text-left">
      <strong> {{ 'Edificio:  ' }} </strong> {{ currentQR.building_name }}
      <br />
      <strong> {{ 'Nivel:  ' }} </strong> {{ currentQR.floor_name }} <br />
      <strong>{{ 'Puesto:  ' }}</strong> {{ currentQR.workplace_name }}
    </div>
    <div
      class="flex justify-content-center align-content-center mb-3 gap-3 pt-5">
      <shared-button
        mat-dialog-close
        [typeBtn]="'button'"
        [icon]="'clear'"
        [color]="'warn'"
        >Cerrar
      </shared-button>
      <shared-button
        (click)="loadImg()"
        [routerLink]="['admin/pdf']"
        [typeBtn]="'submit'"
        [icon]="'cloud_download'"
        [color]="'accent'">
        Descargar QR
      </shared-button>
    </div>
  </div>
</div>
